import { MatDialogModule } from '@angular/material/dialog';
import { DaveSharedComponentsModule } from './../../../../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { DaveLoadingModule } from './../../../../dave-loading/dave-loading.module';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { AppButtonModule } from "../../../../dave-utils-module/app-button-module/app-button.module";
import { NewVacationComponent } from "./new-vacation.component";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { SmallFileCardModule } from '../../../../small-file-card/small-file-card.module';


@NgModule({
    declarations: [
        NewVacationComponent,
    ],
    imports: [
        CommonModule,
        MatCardModule,
        AppButtonModule,
        MatTooltipModule,
        ReactiveFormsModule,
        MatInputModule,
        FontAwesomeModule,
        DaveLoadingModule,
        DaveSharedComponentsModule,
        MatDialogModule,
        MatCheckboxModule,
        MatFormFieldModule,
        DropzoneModule,
        SmallFileCardModule,
    ],
})
export class NewVacationModule {
}
